<div *ngIf="isShow" class="text-center centered-general-alert-div" [ngClass]="page">
    <div class="alerts-div server-alert">
        <div class="alert-text">
            <div [innerHTML]="alertText"></div>
            <div class="row justify-content-center">
                <button type="button" class="close server" (click)="close()" aria-label="Close">
                    <span aria-hidden="true">סגור חלון</span>
                </button>
            </div>
        </div>
    </div>
</div>
